import { Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import type { OnInit } from '@angular/core';
import { AlertController, IonModal, IonSearchbar } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor  } from '@capacitor/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-select-search',
  templateUrl: './select-search.component.html',
  styleUrls: ['./select-search.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true
})
export class SelectSearchComponent implements OnInit {
  @ViewChild('searchBar') searchBar: IonSearchbar | null = null;

  @Input() enableAutoFocus: Boolean = true;
  @Input() isEmbed: Boolean = false;
  @Input() items: any[] = [];
  @Input() selectedItem: number | null = null;
  @Input() title = 'Select Items';
  @Input() enableFilter: Boolean = true;

  @Output() selectionCancel = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<number | null>();
  @Output() searchChange = new EventEmitter<string | null>();
  
  workingSelectedValues: number | null = null;
  
  ngOnInit() {
    this.workingSelectedValues = this.selectedItem;
    setTimeout(() => {
      if(this.enableAutoFocus)
        this.searchBar?.setFocus();
    }, 150);
  }
  
  trackItems(index: number, item: any) {
    return item.id;
  }
  
  cancelChanges() {
    this.selectionCancel.emit();
    this.selectionChange.emit(this.workingSelectedValues);
  }
  
  confirmChanges() {
    this.selectionChange.emit(this.workingSelectedValues);
  }
  
  searchbarInput(ev: any) {
    this.searchChange.emit(ev.target.value);
  }
  
  radioGroupChange(itemId: any) {
    this.workingSelectedValues = itemId;
    this.confirmChanges();
  }

  setToNull() {
    this.workingSelectedValues = null;
    this.selectionChange.emit(this.workingSelectedValues);
  }

}
